import { useContext, useState, useEffect } from "react";
// import kiapay from "./assets/Images/kkiapay.png";
import KkiaPay from "./kkiapay";
import { openKkiapayWidget } from "kkiapay";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { fetchCommandes } from "../Store/CommandesSlice";
import { toast } from "react-toastify";
import { PanierContext } from "../Store/Panier_context";
import API from "./Authentification/api";
// import mtn from "./assets/Images/momo_img.png";
import MomoPay from "./MomoPay";
import { useNavigate } from "react-router-dom";
import { getProductImage } from "../Utils/Cloudinary";
import Flag from "react-world-flags";
import {
  IconMapPin,
  IconTruckDelivery,
  IconEdit,
  IconCircleCheck,
  IconAlertCircle,
  IconBuildingCommunity,
  IconRoad,
  IconHome2,
  IconNotes,
  IconCreditCard,
  IconChevronRight,
  IconCurrentLocation,
  IconRoute,
} from "@tabler/icons-react";
import CheckoutStepper from "./CheckoutStepper";
// import "./Paiement.css";

const CHECKOUT_STEPS = ["Panier", "Adresse", "Paiement"];

/* ==========================================================================
   Champ texte avec label flottant, réutilisable pour tout le formulaire
   ========================================================================== */
const FloatingField = ({
  id,
  label,
  value,
  onChange,
  icon,
  required,
  disabled,
  as = "input",
  rows = 3,
  error,
  autoComplete,
  type = "text",
}) => {
  const isFilled = value && value.length > 0;
  const Tag = as === "textarea" ? "textarea" : "input";

  return (
    <div className="checkout-field">
      <div style={{ position: "relative" }}>
        {icon && <span className="checkout-field-icon">{icon}</span>}
        <Tag
          id={id}
          type={as === "textarea" ? undefined : type}
          rows={as === "textarea" ? rows : undefined}
          className={`${as === "textarea" ? "checkout-field-textarea" : "checkout-field-input"} ${icon ? "has-icon" : ""
            } ${isFilled ? "is-filled" : ""} ${error ? "is-invalid" : ""}`}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          placeholder=" "
        />
        <label htmlFor={id} className="checkout-field-label">
          {label} {required && <span className="checkout-required">*</span>}
        </label>
      </div>
      {error && (
        <div className="checkout-field-error">
          <IconAlertCircle size={14} />
          {error}
        </div>
      )}
    </div>
  );
};

const Paiement = () => {
  const { products, clearCart } = useContext(PanierContext);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPopUp, setshowPopUp] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [openKkiaPay, setOpenKkiaPay] = useState(false);
  const [loadingLivraison, setLoadingLivraison] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [phoneFocused, setPhoneFocused] = useState(false);

  const closePopUp = () => setshowPopUp(false);
  const openPopup = () => setshowPopUp(true);

  const [coords, setCoords] = useState(null); // { lat, lng }
  const [geoLoading, setGeoLoading] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(null);
  const [deliveryDistance, setDeliveryDistance] = useState(null);

  const formatPrice = (price) => {
    const numericValue = typeof price === "string" ? parseFloat(price) : price;
    return new Intl.NumberFormat("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numericValue);
  };

  const requestGeolocation = () => {
    if (!navigator.geolocation) {
      toast.error("La géolocalisation n'est pas disponible sur ce navigateur.");
      return;
    }

    setGeoLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setCoords({ lat: latitude, lng: longitude });

        try {
          const response = await API.post("/delivery/estimate", {
            latitude,
            longitude,
          });
          setDeliveryDistance(response.data.distance_km);
          setDeliveryFee(response.data.fee);
          toast.success(
            `Position enregistrée · ${response.data.distance_km} km · ${response.data.fee} FCFA de livraison`,
          );
        } catch (error) {
          if (process.env.NODE_ENV !== "production") {
            console.error("Erreur estimation frais de livraison:", error);
          }
          toast.error("Impossible de calculer les frais de livraison pour l'instant.");
        } finally {
          setGeoLoading(false);
        }
      },
      () => {
        setGeoLoading(false);
        toast.error(
          "Impossible d'obtenir votre position. Autorisez la géolocalisation dans votre navigateur.",
        );
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  useEffect(() => {
    document.body.style.overflow = showPopUp ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopUp]);

  const totalPrice = products.reduce(
    (acc, product) => acc + product.price * product.quantity,
    0,
  );

  const [adresse, setAdresse] = useState({
    ville: "",
    quartier: "",
    rue: "",
    numero: "",
    localisation: "",
  });

  const [phone, setPhone] = useState("");
  const [adresseValidee, setAdresseValidee] = useState(false);
  const [user, setUser] = useState({ firstName: "", email: "" });

  const adresseRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s,'-]{3,200}$/;
  const adresseComplete = `${adresse.ville}, ${adresse.quartier}, ${adresse.rue}, ${adresse.numero}, ${adresse.localisation}`;

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = value.slice(0, 10);
    value = value.replace(/(\d{2})(?=\d)/g, "$1 ");
    setPhone(value);
    setErrors({});
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        const response = await API.get("/user");
        if (response.status === 200 && response.data) {
          setUser({
            firstName: response.data.firstName || "",
            email: response.data.email || "",
          });
          if (response.data.phone) {
            setPhone(response.data.phone);
          }
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error("Erreur récupération utilisateur:", error.message);
        }
      }
    };
    fetchUser();
  }, []);

  const handleAdresseSubmit = (e) => {
    e.preventDefault();
    const cleanPhone = phone.replace(/\s/g, "");
    let newErrors = {};

    if (!cleanPhone.trim()) {
      newErrors.phone = "Veuillez entrer un numéro de téléphone";
    } else if (!/^01\d{8}$/.test(cleanPhone)) {
      newErrors.phone = "Le numéro doit commencer par 01 et contenir 10 chiffres.";
    } else {
      const secondPair = parseInt(cleanPhone.substring(2, 4), 10);
      if (secondPair < 50 || secondPair > 99) {
        newErrors.phone = "Les deux chiffres après '01' doivent être compris entre 50 et 99.";
      }
    }

    if (!adresse.ville) newErrors.ville = "Champ obligatoire";
    if (!adresse.quartier) newErrors.quartier = "Champ obligatoire";
    if (!adresse.localisation) {
      newErrors.localisation = "Champ obligatoire";
    } else if (!adresseRegex.test(adresse.localisation)) {
      newErrors.localisation = "Adresse invalide, veuillez corriger.";
    }

    if (!coords) {
      newErrors.position = "Veuillez partager votre position pour calculer les frais de livraison.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Veuillez corriger les champs indiqués.");
      return;
    }

    setErrors({});
    toast.success("Adresse validée !");
    setAdresseValidee(true);
    setCurrentStep(2);
  };

  const handleEditAddress = () => {
    setAdresseValidee(false);
    setCurrentStep(1);
  };

  const handleSuccess = async (payment) => {
    if (!adresseValidee) {
      toast.error("Veuillez d'abord valider votre adresse de livraison.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Session expirée. Veuillez vous reconnecter.");
        window.location.href = "/login";
        return;
      }

      const payload = {
        transactionId: payment.transactionId ?? payment.transaction_id ?? null,
        amount: totalPrice,
        cart: products,
        phone: phone.replace(/\s/g, ""),
        address: adresseComplete,
        latitude: coords?.lat ?? null,
        longitude: coords?.lng ?? null,
        requestId: payment.requestId ?? payment.request_id ?? null,
        paymentData: payment,
      };

      const response = await API.post("/paiement/kkiapay/callback", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.status === 200) {
        clearCart();
        dispatch(fetchCommandes(1));
        toast.success("Paiement effectué et commande enregistrée !", { autoClose: 2000 });
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Erreur lors du traitement de la commande (Paiement):", error);
      }
      if (error?.response?.status === 422 && error.response.data?.errors) {
        toast.error(error.response.data.errors);
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Erreur lors du traitement de la commande.");
      }
    }
  };

  const handlePaiementLivraison = async () => {
    if (!adresseValidee) {
      toast.error("Veuillez d'abord valider votre adresse de livraison.");
      return;
    }
    try {
      setLoadingLivraison(true);
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Session expirée. Veuillez vous reconnecter.");
        navigate("/login");
        return;
      }

      const payload = {
        payment_method: "livraison",
        amount: totalPrice,
        cart: products,
        address: adresseComplete,
        phone: phone.replace(/\s/g, ""),
        latitude: coords?.lat ?? null,
        longitude: coords?.lng ?? null,
      };

      const response = await API.post("/paiement/livraison", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.status === 200 || response?.status === 201) {
        clearCart();
        dispatch(fetchCommandes(1));
        toast.success("Commande enregistrée avec succès.", {
          autoClose: 2000,
        });
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Erreur paiement à la livraison:", error);
      }
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Erreur lors de l'enregistrement de la commande.");
      }
    } finally {
      setLoadingLivraison(false);
    }
  };

  return (
    <div className="checkout-page">
      <div className="container">
        <CheckoutStepper steps={CHECKOUT_STEPS} currentStep={currentStep + 1} />

        <div className="row">
          {/* ================= FORMULAIRE D'ADRESSE ================= */}
          <div className="col col-lg-8 mb-4 me-lg-3 mx-2 mx-lg-0">
            <div className="checkout-card">
              <div className="checkout-card-header">
                <h2 className="checkout-card-title">
                  <IconMapPin size={22} />
                  Informations de livraison
                </h2>
                {adresseValidee && (
                  <button className="checkout-edit-btn" onClick={handleEditAddress} type="button">
                    <IconEdit size={16} />
                    Modifier
                  </button>
                )}
              </div>

              {adresseValidee ? (
                <div className="checkout-address-summary">
                  <IconCircleCheck size={22} />
                  <div className="checkout-address-summary-text">
                    <strong>Adresse validée</strong>
                    {adresseComplete}
                    <br />
                    +229 {phone}
                    {deliveryDistance !== null && (
                      <>
                        <br />
                        {deliveryDistance} km de livraison · {formatPrice(deliveryFee)} FCFA
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <form onSubmit={handleAdresseSubmit} noValidate>
                  {/* Position GPS — nécessaire pour calculer les frais de livraison */}
                  <div className="checkout-geo-box">
                    <button
                      type="button"
                      className="checkout-geo-btn"
                      onClick={requestGeolocation}
                      disabled={geoLoading}
                    >
                      {geoLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        <IconCurrentLocation size={18} />
                      )}
                      {coords ? "Position mise à jour" : "Utiliser ma position actuelle"}
                    </button>

                    {coords && deliveryFee !== null && (
                      <div className="checkout-geo-result">
                        <IconRoute size={16} />
                        <span>
                          {deliveryDistance} km · frais de livraison estimés :{" "}
                          <strong>{formatPrice(deliveryFee)} FCFA</strong>
                        </span>
                      </div>
                    )}

                    {errors.position && (
                      <div className="checkout-field-error">
                        <IconAlertCircle size={14} />
                        {errors.position}
                      </div>
                    )}
                  </div>
                  {/* Téléphone */}
                  <div className="checkout-field">
                    <div
                      className={`checkout-phone-field ${phoneFocused ? "is-focused" : ""} ${errors.phone ? "is-invalid" : ""
                        }`}
                    >
                      <span className="checkout-phone-prefix">
                        <Flag code="BJ" style={{ width: "18px" }} />
                        +229
                      </span>
                      <div className="checkout-phone-input-wrap">
                        <input
                          id="phone"
                          type="tel"
                          value={phone}
                          onChange={handlePhoneChange}
                          onFocus={() => setPhoneFocused(true)}
                          onBlur={() => setPhoneFocused(false)}
                          disabled={adresseValidee}
                          autoComplete="tel-national"
                          className={phone.length > 0 ? "is-filled" : ""}
                          placeholder=" "
                        />
                        <label htmlFor="phone">
                          Numéro de téléphone <span className="checkout-required">*</span>
                        </label>
                      </div>
                    </div>
                    {errors.phone && (
                      <div className="checkout-field-error">
                        <IconAlertCircle size={14} />
                        {errors.phone}
                      </div>
                    )}
                  </div>

                  {/* Ville / Quartier */}
                  <div className="checkout-grid-2">
                    <FloatingField
                      id="ville"
                      label="Ville"
                      required
                      icon={<IconBuildingCommunity size={18} />}
                      value={adresse.ville}
                      onChange={(e) => setAdresse({ ...adresse, ville: e.target.value })}
                      disabled={adresseValidee}
                      error={errors.ville}
                      autoComplete="address-level2"
                    />
                    <FloatingField
                      id="quartier"
                      label="Quartier"
                      required
                      icon={<IconMapPin size={18} />}
                      value={adresse.quartier}
                      onChange={(e) => setAdresse({ ...adresse, quartier: e.target.value })}
                      disabled={adresseValidee}
                      error={errors.quartier}
                    />
                  </div>

                  {/* Rue / Numéro */}
                  <div className="checkout-grid-2">
                    <FloatingField
                      id="rue"
                      label="Rue"
                      icon={<IconRoad size={18} />}
                      value={adresse.rue}
                      onChange={(e) => setAdresse({ ...adresse, rue: e.target.value })}
                      disabled={adresseValidee}
                      autoComplete="address-line1"
                    />
                    <FloatingField
                      id="numero"
                      label="N° de maison"
                      icon={<IconHome2 size={18} />}
                      value={adresse.numero}
                      onChange={(e) => setAdresse({ ...adresse, numero: e.target.value })}
                      disabled={adresseValidee}
                    />
                  </div>

                  {/* Localisation */}
                  <FloatingField
                    id="localisation"
                    label="Précisez la localisation (repère, quartier proche...)"
                    required
                    as="textarea"
                    icon={<IconNotes size={18} />}
                    value={adresse.localisation}
                    onChange={(e) => setAdresse({ ...adresse, localisation: e.target.value })}
                    disabled={adresseValidee}
                    error={errors.localisation}
                  />

                  <button type="submit" className="checkout-submit-btn" disabled={adresseValidee}>
                    Valider l'adresse
                    <IconChevronRight size={18} />
                  </button>

                  <div className="checkout-hint">
                    <IconAlertCircle size={14} />
                    Vous pourrez procéder au paiement une fois l'adresse validée.
                  </div>
                </form>
              )}
            </div>
          </div>

          {/* ================= PANIER ET PAIEMENT ================= */}
          <div className="mb-4 col-lg col-12">
            <div className="checkout-summary-card">
              <div className="checkout-products-list">
                {products.map((product) => (
                  <div className="checkout-product-row" key={product.id}>
                    <div className="checkout-product-img">
                      <img alt={product.name} src={getProductImage(product.image)} />
                    </div>
                    <div className="checkout-product-info">
                      <div className="checkout-product-category">{product.category}</div>
                      <div className="checkout-product-name">{product.name}</div>
                      <div className="checkout-product-meta">
                        {product.sous_category} · Qté {product.quantity}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="checkout-totals">
                <div className="checkout-totals-row">
                  <span>Sous-total</span>
                  <span>{formatPrice(totalPrice)} FCFA</span>
                </div>
                <div className="checkout-totals-row">
                  <span>Livraison</span>
                  <span>{deliveryFee !== null ? `${formatPrice(deliveryFee)} FCFA` : "À calculer"}</span>
                </div>
                <div className="checkout-totals-row checkout-total-final">
                  <span>Total</span>
                  <span className="checkout-total-amount"> {formatPrice(totalPrice + (deliveryFee ?? 0))} FCFA</span>
                </div>
              </div>

              {/* ================== MODE DE PAIEMENT ================== */}
              <div className="checkout-payment-methods">
                <label
                  className={`checkout-payment-option ${paymentMode === "livraison" ? "is-selected" : ""
                    }`}
                >
                  <input
                    type="radio"
                    name="paymentMode"
                    value="livraison"
                    checked={paymentMode === "livraison"}
                    onChange={() => setPaymentMode("livraison")}
                    disabled={!adresseValidee}
                  />
                  <span className="checkout-payment-icon">
                    <IconTruckDelivery size={20} />
                  </span>
                  <div>
                    <div className="checkout-payment-label">Paiement à la livraison</div>
                    <div className="checkout-payment-desc">Payez en espèces à la réception</div>
                  </div>
                </label>

                <button
                  className="checkout-submit-btn"
                  disabled={!paymentMode || !adresseValidee || loadingLivraison}
                  onClick={() => {
                    if (paymentMode === "mobile_money") openPopup();
                    if (paymentMode === "kkiapay") {
                      setOpenKkiaPay(true);
                      openKkiapayWidget({
                        amount: totalPrice,
                        api_key: "461a5930ce9b11f09f4a631e834d10ba",
                        sandbox: true,
                        phone: phone.replace(/\s/g, ""),
                        email: user.email,
                        name: user.firstName,
                        request_id: "KKIA-" + Date.now(),
                      });
                    }
                    if (paymentMode === "livraison") handlePaiementLivraison();
                  }}
                >
                  {loadingLivraison ? (
                    <>
                      <Spinner size="sm" animation="border" />
                      Traitement en cours...
                    </>
                  ) : (
                    <>
                      <IconCreditCard size={18} />
                      Confirmer la commande
                    </>
                  )}
                </button>
                <button
                  type="button"
                  className="checkout-cancel-btn"
                  disabled={loadingLivraison}
                  onClick={() => navigate("/Cart")}
                >
                  Annuler
                </button>
              </div>

              {showPopUp && (
                <MomoPay closePopUp={closePopUp} amount={totalPrice} products={products} />
              )}
              {openKkiaPay && (
                <KkiaPay
                  onSuccess={(data) => {
                    setOpenKkiaPay(false);
                    handleSuccess(data);
                  }}
                  onClose={() => setOpenKkiaPay(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paiement;
